import moment from 'moment';
import {toPhilMoment} from '@/utils/dates';
import {COUPON_NUMBER_OF_DAYS_AFTER_EXPIRY} from '@/reference/medicine';

export default {
  computed: {
    startTime() {
      return toPhilMoment(this.coupon.issuedate);
    },
    startTimeString() {
      return this.startTime.format('MMMM D, YYYY HH:mm:ss');
    },
    endTime() {
      return moment(this.startTime).add(COUPON_NUMBER_OF_DAYS_AFTER_EXPIRY, 'days');
    },
    endTimeString() {
      return this.endTime.format('MMMM D, YYYY HH:mm:ss');
    },
  }
}